import {createSlice} from '@reduxjs/toolkit'

// Window.Shifts type is declared in storeSlice.ts

const initialState = {
    shifts: window.Shifts ?? []
}

console.log('ShiftsSlice initial data from window.Shifts:', initialState)

export const shiftsSlice = createSlice({
    name: 'shifts',
    initialState,
    reducers:{
        setShifts:(state,action)=>{
            state.shifts=action.payload;
        }}
})


export const {setShifts}=shiftsSlice.actions;

export default shiftsSlice.reducer